import { motion } from 'framer-motion';
import { Sparkles, ChevronRight } from 'lucide-react';

/**
 * Compact home-screen card showing the single strongest per-supplement
 * correlation the user has surfaced (from /api/wellness/correlation).
 * Renders nothing if `insight` is falsy — parent decides when to show it.
 */
export default function TopInsightCard({ insight, onClick }) {
  if (!insight) return null;
  const positive = insight.diff_percent > 0;
  const pillColor = positive
    ? 'bg-emerald-100 text-emerald-700 border-emerald-200'
    : 'bg-orange-100 text-orange-700 border-orange-200';

  return (
    <motion.button
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      onClick={onClick}
      className="w-full text-left p-4 rounded-2xl bg-gradient-to-br from-violet-50 to-fuchsia-50 border border-violet-200/70 hover:border-violet-300 transition-colors group"
      data-testid="top-insight-card"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-white/70 flex items-center justify-center flex-shrink-0 shadow-sm">
          <Sparkles className="w-4 h-4 text-violet-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-violet-700/80 mb-0.5">
            What&apos;s working for you
          </p>
          <div className="flex items-center gap-2 flex-wrap">
            <p className="font-semibold text-sm text-[#1A1A1A] truncate">
              {insight.supplement}
            </p>
            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold border ${pillColor}`}>
              {positive ? '+' : ''}{insight.diff_percent}%
            </span>
          </div>
          <p className="text-xs text-violet-800/80 mt-1 leading-snug">
            {insight.on_avg}/5 on {insight.metric.toLowerCase()} vs {insight.off_avg}/5 without · {insight.on_days + insight.off_days} days
          </p>
        </div>
        <ChevronRight className="w-4 h-4 text-violet-500 group-hover:translate-x-0.5 transition-transform flex-shrink-0 mt-2" />
      </div>
    </motion.button>
  );
}
